import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { ButtonWithGAClickButton, ModalHeader, Typography, UtpCardModal } from 'common/components';

export const MaterialCalculation: React.FC<UtpCardModal> = ({ elementBlock = '', onClick }) => (
  <>
    <ModalHeader title="Рассчитаем материалы" />
    <ModalContent>
      <Typography variant="m" size="body_long">
        Поможем выбрать и&nbsp;рассчитать материалы для вашего проекта. А&nbsp;ещё предложим выгодные условия
        покупки и&nbsp;будем на&nbsp;связи по&nbsp;любым вопросам.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={elementBlock}
        elementName="Записаться на консультацию"
        elementText="Рассчитаем материалы"
        onClick={onClick}
        wide>
        Записаться на консультацию
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
